module.exports = __webpack_public_path__ + "media/images/element/02-3d25e20f4b11560db0fd3a75696574b0.png";